<template>
  <a style="text-decoration: none;" :href="href" @click.prevent="scroll">
    <slot>
    </slot>
  </a>
</template>

<script>
export default{
  props:{
    href: String,
    offset: Number 
  },

  methods:{
    scroll(){
      const offset = this.offset;

      if(offset <=100){
        //offset.value = 100;
      }
      // Calculate the offset from the top of the element
      const elementPosition = document.querySelector(this.href).getBoundingClientRect().top + window.scrollY;

      //Checks if it's the home button
      if(!document.querySelector(this.href)){
        var options = {
            top: 0,
            behavior: 'smooth'
        };

        window.scrollTo({options});

        return;
      }
      
      this.$nextTick(() => {
        // Using smooth scroll behavior and offset
        window.scrollTo({
            top: elementPosition - offset,
            behavior: 'smooth'
          }
        );
      })
    }
  }
}
</script>
<style>

</style>